import { createSvgIcon } from "@mui/material";

const SmartViewsIcon = createSvgIcon(
  <svg viewBox="0 0 49 48" fill="none">
    <path
      d="M0.399902 12.1905C0.399902 5.45786 6.13066 0 13.1999 0H35.5999C42.6691 0 48.3999 5.45786 48.3999 12.1905V35.8095C48.3999 42.5421 42.6691 48 35.5999 48H13.1999C6.13066 48 0.399902 42.5421 0.399902 35.8095V12.1905Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M13.3179 13.4797C13.3179 11.7124 14.7506 10.2797 16.5179 10.2797H36.3546C38.1219 10.2797 39.5546 11.7124 39.5546 13.4797V29.7528C39.5546 31.5201 38.1219 32.9528 36.3546 32.9528H16.5179C14.7506 32.9528 13.3179 31.5201 13.3179 29.7528V13.4797Z"
      fill="#DADEFC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5964 19.0828C18.1119 19.0828 18.5298 19.5007 18.5298 20.0162V28.8085C18.5298 29.324 18.1119 29.7419 17.5964 29.7419C17.081 29.7419 16.6631 29.324 16.6631 28.8085V20.0162C16.6631 19.5007 17.081 19.0828 17.5964 19.0828Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3703 21.8464C23.8858 21.8464 24.3037 22.2642 24.3037 22.7797L24.3037 28.8086C24.3037 29.324 23.8858 29.7419 23.3703 29.7419C22.8549 29.7419 22.437 29.324 22.437 28.8086L22.437 22.7797C22.437 22.2642 22.8549 21.8464 23.3703 21.8464Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.1443 17.3854C29.6597 17.3854 30.0776 17.8033 30.0776 18.3188L30.0776 28.8088C30.0776 29.3242 29.6597 29.7421 29.1443 29.7421C28.6288 29.7421 28.2109 29.3242 28.2109 28.8088L28.2109 18.3188C28.2109 17.8033 28.6288 17.3854 29.1443 17.3854Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.9182 13.5748C35.4337 13.5748 35.8515 13.9926 35.8515 14.5081L35.8515 28.8087C35.8515 29.3242 35.4337 29.742 34.9182 29.742C34.4027 29.742 33.9849 29.3242 33.9849 28.8087L33.9849 14.5081C33.9849 13.9926 34.4027 13.5748 34.9182 13.5748Z"
      fill="#4453C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4128 10.8763C10.9283 10.8763 11.3462 11.2941 11.3462 11.8096V32.5739C11.3462 33.8258 12.361 34.8406 13.6128 34.8406H38.387C38.9025 34.8406 39.3204 35.2585 39.3204 35.7739C39.3204 36.2894 38.9025 36.7073 38.387 36.7073H13.6128C11.33 36.7073 9.47949 34.8567 9.47949 32.5739V11.8096C9.47949 11.2941 9.89736 10.8763 10.4128 10.8763Z"
      fill="#4453C6"
    />
  </svg>,
  "SmartViewsIcon"
);

export default SmartViewsIcon;
